import { useState, useEffect } from "react";
import "./Carousel2.scss";
import arrow from "../../assets/icons/arrow-black.svg";

const Carousel2 = ({ images }) => {
    const [current, setCurrent] = useState(0);

    const prevSlide = () => {
        setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const nextSlide = () => {
        setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [current]);

    return (
        <div className="VirasatV2-Carousel2">
            <div className="VirasatV2-Carousel2-preview">
                <div className="arrow left" onClick={prevSlide}>
                    <img alt="" src={arrow} />
                </div>
                <img src={images[current].src} alt="" className="VirasatV2-Carousel2-preview-img" />
                <div className="arrow right" onClick={nextSlide}>
                    <img alt="" src={arrow} />
                </div>
            </div>
            <div className="VirasatV2-Carousel2-content">
                <div className="VirasatV2-Carousel2-content-header">{images[current].header}</div>
                <div className="VirasatV2-Carousel2-content-subheader">{images[current].subheader}</div>
            </div>
            <div className="VirasatV2-Carousel2-thumbs">
                {images.map((img, i) => (
                    <img
                        key={i}
                        src={img.src}
                        alt=""
                        className={`VirasatV2-Carousel2-thumbs-img ${i === current ? "active" : ""}`}
                        onClick={() => setCurrent(i)}
                    />
                ))}
            </div>
        </div>
    );
};

export default Carousel2;
